<template>
  <div class="body">
    <div class="etc-pic">
      <div class="etc-font">{{eleOrder.spec_name}}</div>
      <div style="display:flex;width:100%;justify-content:center;">
        <swiper v-if="eleOrder.final_pic_name.length>1&&swiperShow" @slideChange='slideChange' :options="swiperOption" ref="mySwiper">
					<swiper-slide v-for="item in eleOrder.final_pic_name" :key="item">
						<div class='image-dig'>
							<img class='preview' :src="item"  />
						</div>
					</swiper-slide>
				</swiper>
        <div class='image-dig' v-if="eleOrder.final_pic_name.length===1">
          <img class='preview' :src="eleOrder.final_pic_name[0]"  />
        </div>
      </div>
      <div v-if="eleOrder.final_pic_name.length>1" class="progr">{{activeIndex}} / {{eleOrder.final_pic_name.length}}</div>
    </div>
    <div class="etc-dialog_container">
      <div class="dialog-head">
        <div class="head-font">
          <div class="head-bank fix-1px"></div>
          <div class="head-bank"></div>
        </div>
        <div>
          <div class="ot-color">保存电子照</div>
        </div>
        <div class="head-font">
          <div class="head-bank fix-1px"></div>
          <div class="head-bank"></div>
        </div>
      </div>
      <div style="width:100%;height:40px;"></div>
      <div class="dialog-icon">
        <img @click="choiceTap(1)"
             class="icon-img"
             src="../assets/download_icon_phone@3x.png" />
        <img @click="choiceTap(2)"
             class="icon-img"
             src="../assets/download_icon_key@3x.png" />
        <!-- <image class="icon-img" src="" /> -->
        <img @click="choiceTap(3)"
             class="icon-img"
             src="../assets/download_icon_email@3x.png" />
      </div>
      <div class="dialog-font">
        <div class="icon-nocolor">保存到手机</div>
        <div class="icon-nocolor">提取码</div>
        <div class="icon-nocolor">发送到邮箱</div>
      </div>
      <div style="width:100%;height:20px;"></div>
    </div>
    <DownModel @hide="hide"
               @choiceTap="choiceTap"
               :showFlag="showFlag"
               :extractCode="extractCode"
               :orderId="eleOrder.order_id"
               :choiceNum="choiceNum"></DownModel>
  </div>
</template>

<script>
import DownModel from "../components/DownModel";
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import {mapActions,mapState} from 'vuex';
import 'swiper/dist/css/swiper.css'
import { setTimeout } from 'timers';
export default {
  components: { DownModel,swiper,swiperSlide },
  data () {
    return {
      eleOrder:{
        final_pic_name:[]
      },
      swiperShow:true,
      activeIndex:1,
      choiceNum:0,
      extractCode:{
        extract_code:'',
        url:''
      },
      swiperOption:{
        loop : true,
        centeredSlides: true,
        slidesPerView: 2,
        effect : 'coverflow',
        autoplay: {
        delay: 5000,
        stopOnLastSlide: false,
        disableOnInteraction: true,
        },
        coverflowEffect: {
          rotate: 0,
          stretch: -30,
          depth: 100,
          modifier: 1,
          slideShadows : false
        },
      },
      showFlag: false,
    }
  },
  computed:{
    ...mapState(['actiBol','processedPhoto'])
  },
  activated(){
    if(!this.actiBol){
      return;
    }
    let paramorder = this.$route.params.eleorder;
    let id = paramorder?paramorder.order_id: this.$route.query.id;
    if(paramorder){
      paramorder.final_pic_name=paramorder.type==='marriage'?[paramorder.final_pic_name[0]]:paramorder.final_pic_name
      this.eleOrder = paramorder;
    }
    console.log(this.eleOrder)
    console.log("processedPhoto:::",this.processedPhoto)
    this.swiperShow = true;//初始化轮播
    this.activeIndex = 1;//初始化轮播索引
    this.handleCode({
      order_id:id,
      payenter:!paramorder
    })
  },
  deactivated(){
    this.swiperShow = false;//毁掉swiper
  },
  methods: {
    ...mapActions(["getCode"]),
    handleCode(data){
      this.getCode(data).then(res=>{
        this.extractCode=res[0];
        if(data.payenter){
          let {specName:spec_name,picinfo:{type}}=this.processedPhoto
          this.eleOrder = {
            spec_name,
            final_pic_name:type==='marriage'?[res[1].result.final_pic_name[0]]:res[1].result.final_pic_name,
            order_id: data.order_id
          }
        }
      })
    },
    slideChange(){
      let index = this.activeIndex;
      this.activeIndex=index>=this.eleOrder.final_pic_name.length?1:++index
    },
    hide () {
      this.showFlag = false
    },
    choiceTap (idx) {
      this.choiceNum = idx
      this.showFlag = true
    },
  },
}
</script>

<style scoped>
.progr{
  text-align: center;
  margin-top: 0.1rem;
  font-size: 0.12rem;
  color: #999999;
}
.ot-color {
  color: #666666;
  font-size: 0.12rem;
  line-height: 0.48rem;
}
.fix-1px {
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: #e5e5e5;
}
.image-dig{
	  padding:0.06rem;
	  width: 2rem;
	  background-color: white;
	}
	.preview {
	  width: 100%;
	  vertical-align: middle;
	}
.icon-font {
  color: #f5a623;
  font-size: 0.12rem;
  margin-left: 0.35rem;
  margin-right: 0.35rem;
}
.icon-nocolor {
  color: #999999;
  font-size: 0.12rem;
  margin-left: 0.35rem;
  margin-right: 0.35rem;
}
.icon-img {
  height: 0.5rem;
  width: 0.5rem;
  margin-left: 0.35rem;
  margin-right: 0.35rem;
}
.dialog-font {
  margin-top: 0.05rem;
  height: 0.25rem;
  width: 100%;
  display: flex;
  justify-content: space-between;
  font-size: 0.12rem;
}
.dialog-icon {
  /* height: 150rpx; */
  width: 100%;
  display: flex;
  justify-content: center;
}
.head-font {
  font-size: 0.12rem;
  color: #666666;
  line-height: 0.32rem;
  margin: 0.1rem;
  flex-direction: column;
  /* float: left; */
}
.head-bank {
  height: 0.16rem;
  width: 0.23rem;
}
.dialog-head {
  height: 0.5rem;
  width: 100%;
  display: flex;
  justify-content: center;
}
.etc-dialog_container {
  background-color: #ffffff;
  width: 100%;
  position: fixed;
  bottom: 0px;
  flex-direction: column;
}
.etc-pic {
  justify-content: center;
  flex-direction: column;
}
.img {
  width: 2rem;
  height: 2.7rem;
  margin-top: 0.2rem;
}
.etc-font {
  color: #333333;
  font-size: 0.17rem;
  display: flex;
  justify-content: center;
  margin-top: 0.3rem;
  margin-bottom: 0.2rem;
  word-break: break-all;
  padding:0 0.1rem;
}
</style>
